var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "overflow-auto h-100" }, [
    _vm.hasItems
      ? _c(
          "div",
          { staticClass: "item-list" },
          _vm._l(_vm.items, function (item) {
            return _c("list-item", {
              key: item.model.id,
              staticClass: "item-list__item",
              class: { "item-list__item_current": _vm.isCurrent(item) },
              attrs: { row: item },
              on: { select: _vm.onSelect, toggle: _vm.onToggle },
            })
          }),
          1
        )
      : !_vm.isRequestActive
      ? _c(
          "div",
          {
            staticClass:
              "h-100 d-flex align-items-center justify-content-center text-muted-light font-weight-bold",
          },
          [_vm._v("\n    Empty\n  ")]
        )
      : _c(
          "div",
          {
            staticClass:
              "h-100 d-flex align-items-center justify-content-center",
          },
          [_c("i", { staticClass: "fas fa-sync-alt fa-spin" })]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }